<template>
    <div class="status-container" :class="statusClass">
        <span>
            {{ status }}
        </span>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import i18n from '@/plugins/i18n';

export function statusFournisseurName(status: string): string {
    return i18n.global.t(`state.fournisseur.${status}`);
}

export default defineComponent({
    name: 'StatusFournisseurTag',
    props: { status: { type: String, required: true } },
    computed: {
        statusClass() {
            switch (this.$props.status) {
                case this.$t('state.fournisseur.A_VALIDER'):
                    return 'a-valider';
                case this.$t('state.fournisseur.VALIDEE'):
                    return 'validee';
                case this.$t('state.fournisseur.LITIGE'):
                    return 'litige';
                case this.$t('state.fournisseur.REJETEE'):
                    return 'rejetee';
                case this.$t('state.fournisseur.PAYEE'):
                    return 'payee';
                default:
                    return '';
            }
        },
    },
});
</script>

<style scoped>
.status-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 105px;
    height: 24px;
    border-radius: 12px;
    font-size: var(--font-size-very-small);
}
.a-valider {
    background-color: #75a9f9;
}
.validee {
    background-color: #92d36e;
}
.litige {
    background-color: #f06e9c;
}
.rejetee {
    background-color: #ffb253;
}
.payee {
    background-color: #800080D5;
    color: white;
}
</style>
